import useLogout from "features/Logout/hooks/useLogout";
import useResponsive from "hooks/useResponsive";
import useRoleActive from "hooks/useRoleActive";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConfigPromp } from "routes/context";
import { ROUTES } from "routes/routes";
import useUser from "state/User/useUser";

const useHeaderBase = () => {
  const { user } = useUser();
  const { isRoleEPG } = useRoleActive();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const { isTabIndex, isActiveHeader } = useConfigPromp();
  const { isMinorTablet } = useResponsive();
  const logoutRef = useRef<HTMLDivElement | null>(null);
  const [isActiveMenu, setIsActiveMenu] = useState<boolean>(false);
  const [isActiveLogout, setIsActiveLogout] = useState<boolean>(false);

  const handleLogoutClick = () => {
    logout();
  };

  const handleRedirectToSummary = () => {
    navigate(ROUTES.candidate.summary);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      logoutRef.current &&
      !logoutRef.current.contains(event.target as Node)
    ) {
      setIsActiveLogout(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return {
    user,
    logoutRef,
    isRoleEPG,
    isActiveMenu,
    isMinorTablet,
    isActiveLogout,
    isActiveHeader,
    setIsActiveMenu,
    setIsActiveLogout,
    handleLogoutClick,
    tabIndexValue: isTabIndex ? 0 : -1,
    handleRedirectToSummary
  };
};

export default useHeaderBase;
